
      if (import.meta.env.MODE === 'production') {
        const script = document.createElement('script');
        script.src = '/clarify.js';
        script.defer = true;
        document.head.appendChild(script);
      }
    